<template>
  <div
    class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-body">
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
        <div class="card">
          <CarouselCard
            :box="productData"
            :subPage="true"
            :insidePopup="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, watch } from "vue";
import { useStore } from "vuex";
import CarouselCard from "@/components/Carousel/CarouselCard.vue";

export default {
  name: "ModalVideo",
  components: {
    CarouselCard,
  },
  setup() {
    const store = useStore();
    const productId = computed(() => store.state.modal.productId);
    const productData = computed(() =>
      store.getters["purl/getPageOne"](productId.value)
    );

    return { productData };
  },
};
</script>
<style lang="scss" scoped>
.btn-close {
  position: absolute;
  right: 3px;
  top: -17px;
  width: 10px;
  height: 10px;
  padding: 1px;
  opacity: 1;
}
.modal-body {
  padding: 0;
}
.modal-content {
  background: transparent;
  border: none;
}
.modal-sm {
  min-width: 400px;
  // margin: 1.75rem auto 1.75rem 70vw;
  right: 10%;
  position: absolute;
  @media (max-width: 900px) {
    right: 48%;
    transform: translateX(50%) !important;
  }
  @media (max-width: 450px) {
    min-width: 300px;
  }
}
.card {
  overflow: hidden;
  border: none;
  border-radius: 20px;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.17);
}
</style>